import React, { useState } from 'react';

import { TabsContext } from '@app/providers/TabsNotificationProvider/TabsContext';
import type { NTabsNotificationProvider } from '@app/providers/TabsNotificationProvider/TabsNotificationProvider.types';

const Context = React.createContext('');

export const TabsNotificationProvider: NTabsNotificationProvider.Main = ({
  children,
}) => {
  const [originalData, setOriginalData] =
    useState<NTabsNotificationProvider.Context['originalData']>();
  const [newData, setNewData] =
    useState<NTabsNotificationProvider.Context['newData']>();
  const [tabInfo, setTabInfo] = useState('');

  return (
    <TabsContext.Provider
      value={{
        originalData,
        setOriginalData,
        newData,
        setNewData,
        tabInfo,
        setTabInfo,
      }}
    >
      <Context.Provider value={originalData}>{children}</Context.Provider>
    </TabsContext.Provider>
  );
};
